import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { createQueryClient } from './api/queryClient';
import { createAppRouter } from './app/routes';
import { SessionProvider } from './auth/SessionProvider';
import './styles/tokens.css';
import './styles/base.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Missing #root element in index.html');
}

const queryClient = createQueryClient();

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={createAppRouter()} />
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
